/* tslint:disable */
/* eslint-disable */
/**
 * Localingos API
 * Developer-first automated localization platform powered by AI. Sync your project and continuously localize only what changed.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DeleteTranslatablesRequest } from '../models';
// @ts-ignore
import type { DeleteTranslatablesResponse } from '../models';
// @ts-ignore
import type { PostTranslatablesRequest } from '../models';
// @ts-ignore
import type { TranslatableOutputDto } from '../models';
/**
 * TranslatableControllerApi - axios parameter creator
 * @export
 */
export const TranslatableControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {DeleteTranslatablesRequest} deleteTranslatablesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTranslatables: async (projectId: string, deleteTranslatablesRequest: DeleteTranslatablesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('deleteTranslatables', 'projectId', projectId)
            // verify required parameter 'deleteTranslatablesRequest' is not null or undefined
            assertParamExists('deleteTranslatables', 'deleteTranslatablesRequest', deleteTranslatablesRequest)
            const localVarPath = `/translatable/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTranslatablesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslatables: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getTranslatables', 'projectId', projectId)
            const localVarPath = `/translatable/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostTranslatablesRequest} postTranslatablesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslatables: async (postTranslatablesRequest: PostTranslatablesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTranslatablesRequest' is not null or undefined
            assertParamExists('postTranslatables', 'postTranslatablesRequest', postTranslatablesRequest)
            const localVarPath = `/translatable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTranslatablesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranslatableControllerApi - functional programming interface
 * @export
 */
export const TranslatableControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranslatableControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {DeleteTranslatablesRequest} deleteTranslatablesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTranslatables(projectId: string, deleteTranslatablesRequest: DeleteTranslatablesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTranslatablesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTranslatables(projectId, deleteTranslatablesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslatableControllerApi.deleteTranslatables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslatables(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TranslatableOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranslatables(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslatableControllerApi.getTranslatables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PostTranslatablesRequest} postTranslatablesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTranslatables(postTranslatablesRequest: PostTranslatablesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTranslatables(postTranslatablesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslatableControllerApi.postTranslatables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TranslatableControllerApi - factory interface
 * @export
 */
export const TranslatableControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranslatableControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {DeleteTranslatablesRequest} deleteTranslatablesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTranslatables(projectId: string, deleteTranslatablesRequest: DeleteTranslatablesRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteTranslatablesResponse> {
            return localVarFp.deleteTranslatables(projectId, deleteTranslatablesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslatables(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TranslatableOutputDto>> {
            return localVarFp.getTranslatables(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostTranslatablesRequest} postTranslatablesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslatables(postTranslatablesRequest: PostTranslatablesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postTranslatables(postTranslatablesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranslatableControllerApi - object-oriented interface
 * @export
 * @class TranslatableControllerApi
 * @extends {BaseAPI}
 */
export class TranslatableControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} projectId 
     * @param {DeleteTranslatablesRequest} deleteTranslatablesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslatableControllerApi
     */
    public deleteTranslatables(projectId: string, deleteTranslatablesRequest: DeleteTranslatablesRequest, options?: RawAxiosRequestConfig) {
        return TranslatableControllerApiFp(this.configuration).deleteTranslatables(projectId, deleteTranslatablesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslatableControllerApi
     */
    public getTranslatables(projectId: string, options?: RawAxiosRequestConfig) {
        return TranslatableControllerApiFp(this.configuration).getTranslatables(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PostTranslatablesRequest} postTranslatablesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslatableControllerApi
     */
    public postTranslatables(postTranslatablesRequest: PostTranslatablesRequest, options?: RawAxiosRequestConfig) {
        return TranslatableControllerApiFp(this.configuration).postTranslatables(postTranslatablesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

